import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/site-data";

export const Testimonials = () => {
    const [i, setI] = useState(0);
    useEffect(() => {
        const t = setInterval(() => setI((p) => (p + 1) % TESTIMONIALS.length), 6000);
        return () => clearInterval(t);
    }, []);

    return (
        <section id="testimonials" data-testid="testimonials-section" className="py-24 sm:py-32 bg-brand-cream relative overflow-hidden">
            {/* marquee names backdrop */}
            <div className="absolute inset-0 pointer-events-none flex items-center opacity-[0.06] -z-0">
                <div className="marquee whitespace-nowrap font-display text-[10rem] tracking-tighter text-brand-ink">
                    {[...TESTIMONIALS, ...TESTIMONIALS].map((t, idx) => (
                        <span key={idx} className="mx-12">
                            {t.name} <span className="text-brand-coral">·</span>
                        </span>
                    ))}
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6 sm:px-8 relative">
                <p className="text-xs tracking-[0.25em] uppercase text-brand-coral mb-4 text-center">Stories from our guests</p>
                <h2 className="font-display text-4xl sm:text-5xl text-brand-ink text-center mb-14 leading-[1.05]">
                    What people <em className="text-brand-coral">remember</em>.
                </h2>

                <div className="relative min-h-[280px] sm:min-h-[220px]">
                    <AnimatePresence mode="wait">
                        <motion.blockquote
                            key={i}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.6 }}
                            className="text-center"
                            data-testid={`testimonial-${i}`}
                        >
                            <Quote className="h-8 w-8 mx-auto text-brand-coral/60 mb-6" />
                            <p className="font-display text-2xl sm:text-3xl text-brand-ink leading-snug max-w-3xl mx-auto italic font-light">
                                &ldquo;{TESTIMONIALS[i].quote}&rdquo;
                            </p>
                            <div className="mt-8">
                                <div className="text-sm text-brand-ink font-medium">— {TESTIMONIALS[i].name}</div>
                                <div className="text-xs tracking-wider uppercase text-brand-inkSoft mt-1">{TESTIMONIALS[i].event}</div>
                            </div>
                        </motion.blockquote>
                    </AnimatePresence>
                </div>

                <div className="flex items-center justify-center gap-2 mt-10">
                    {TESTIMONIALS.map((_, idx) => (
                        <button
                            key={idx}
                            onClick={() => setI(idx)}
                            data-testid={`testimonial-dot-${idx}`}
                            className={`h-1.5 rounded-full transition-all ${
                                idx === i ? "w-8 bg-brand-coral" : "w-1.5 bg-brand-ink/20"
                            }`}
                            aria-label={`Go to testimonial ${idx + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
